import { applyMiddleware, compose, createStore } from 'redux';
import { BroadcasterMiddleware, LocalStorageMiddleware, MediaSessionMiddleware, NavigationMiddleware, PagePerformanceMiddleware, PlaybackEventsMiddleware, PlaybackMiddleware, ShareMiddleware, SkyfireMethodExecutionMiddleware, SkyfireMethodQueueMiddleware, SkyfireTemplateMiddleware, MultiSelectMiddleware } from '../middlewares/';
import { RootReducer } from '../reducers/RootReducer';
import { globals } from '../utils';
export default function configureStore(initialState = {}) {
    const composeEnhancers = globals.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? globals.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            name: 'DMWebPlayerSkyfire',
        })
        : compose;
    const store = createStore(RootReducer, initialState, composeEnhancers(applyMiddleware(SkyfireMethodQueueMiddleware, SkyfireMethodExecutionMiddleware, SkyfireTemplateMiddleware, PlaybackMiddleware, PlaybackEventsMiddleware, MediaSessionMiddleware, BroadcasterMiddleware, PagePerformanceMiddleware, NavigationMiddleware, LocalStorageMiddleware, ShareMiddleware, MultiSelectMiddleware)));
    window.store = store;
    return store;
}
